export const identifierValidationOptions = [
  { value: 'false', label: 'Número de pedido e email/código postal asociado.' },
  { value: 'true', label: 'Solo número de pedido' },
]
